import { MapPin } from "@phosphor-icons/react";
import { Reveal } from "@/components/Reveal";
import { WhatsAppButton } from "@/components/CTAButtons";
import CityMap from "@/components/CityMap";
import { REGIONS } from "@/data/site";

export default function Regions() {
  return (
    <section id="regioes" className="relative overflow-hidden bg-white py-24 md:py-32" data-testid="regions">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div className="grid gap-14 lg:grid-cols-2 lg:items-center lg:gap-20">
          <div>
            <Reveal>
              <p className="font-mono text-xs uppercase tracking-[0.3em] text-brand-red">Cobertura</p>
              <h2 className="mt-4 font-display text-4xl uppercase leading-[0.95] tracking-tight text-brand-obsidian md:text-6xl">
                Regiões atendidas<br /><span className="text-brand-red">RO & MT</span>
              </h2>
              <p className="mt-6 max-w-md text-base leading-relaxed text-neutral-600">
                Presença estratégica em Rondônia e Mato Grosso com filiais em Pimenta Bueno, Vilhena e
                Sapezal — garantindo o atendimento mais rápido possível na sua região.
              </p>
            </Reveal>

            <div className="mt-8 grid grid-cols-2 gap-x-6 gap-y-1 sm:grid-cols-3">
              {REGIONS.map((r, i) => (
                <Reveal key={r.city} delay={(i % 6) * 0.03}>
                  <div className="flex items-center gap-2 border-b border-black/10 py-2.5">
                    <MapPin weight="fill" className="h-4 w-4 shrink-0 text-brand-red" />
                    <span className="text-sm text-neutral-700">{r.city}</span>
                    <span className="font-mono text-[10px] text-neutral-400">{r.uf}</span>
                  </div>
                </Reveal>
              ))}
            </div>

            <div className="mt-9">
              <WhatsAppButton label="Verificar Atendimento" testid="regions-whatsapp" />
            </div>
          </div>

          <Reveal className="relative">
            <div className="relative z-0 aspect-square w-full overflow-hidden rounded-sm border border-black/10 shadow-lg">
              <CityMap />
              <div className="pointer-events-none absolute left-4 top-4 z-[500] flex items-center gap-2 rounded-sm bg-brand-red px-3 py-1.5 shadow-md">
                <MapPin weight="fill" className="h-4 w-4 text-white" />
                <span className="font-heading text-xs font-semibold uppercase tracking-wide text-white">Cobertura RO &amp; MT</span>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
